import cn from "classnames";

import s from "./CheckBox.module.scss";

const CheckBox = ({
  className,
  checked,
  onChange,
  error,
  disabled = false,
  dark = true,
  ...props
}) => {
  return (
    <div
      className={cn(
        s.checkBox,
        checked && s.checked,
        error && s.error,
        className,
        dark && s.dark,
      )}
      onClick={!disabled ? onChange : () => {}}
      {...props}
    />
  );
};

export default CheckBox;
